module.exports = __webpack_public_path__ + "static/media/leagueBotInitials.63005134.png";